<template>
  <div ref="tab" class="purchase-box">
    <div class="purchase-headers" :class="'headers-background-'+purchaseInfo.purApplyStatus">
      <headers
        :headInfo="{headUrl: purchaseInfo.dingDingPhotoPath, dingdingUserId:purchaseInfo.currentApplyDingDingId, userName: purchaseInfo.currentApplyEmployeeName, approver: purchaseInfo.nextApprover, approvalState: purchaseInfo.purApplyStatus }"
      ></headers>
    </div>
    <div ref="purchase_tab" class="purchase-tab">
      <tab :tabconfig="tabconfig"></tab>
    </div>
    <div class="mian-box">
      <div class="purchase-info d_jump">
        <div class="purchase-info-content">
          <div v-if="purchaseInfo.purchaseID!=null" class="purchase-info-box">
            <div class="purchase-info-label">采购单号</div>
            <div class="purchase-info-content">{{purchaseInfo.purchaseID}}</div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">采购项目</div>
            <div class="purchase-info-content">{{purchaseInfo.applyName}}</div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">申请时间</div>
            <div class="purchase-info-content">{{purchaseInfo.applyDate|yyyy-MM-dd}}</div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">采购分类</div>
            <div class="purchase-info-content">{{purchaseInfo.purchaseKindName}}</div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">需求人</div>
            <div class="purchase-info-content">{{purchaseInfo.requirementName}}</div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">需求部门</div>
            <div class="purchase-info-content">{{purchaseInfo.requirementDeptName}}</div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">采购预算</div>
            <div class="purchase-info-content">{{purchaseInfo.purchaseBudget|NumFormat}}元</div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">采购必要性</div>
            <div class="purchase-info-content" v-html="$options.filters.textareaToFormat(purchaseInfo.purchaseNecessity)"></div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">验收要求</div>
            <div class="purchase-info-content" v-html="$options.filters.textareaToFormat(purchaseInfo.checkDemand)"></div>
          </div>
          <div v-if="purchaseInfo.biddingType!=null" class="purchase-info-box">
            <div class="purchase-info-label">招标方式</div>
            <div class="purchase-info-content">{{purchaseInfo.biddingTypeName}}</div>
          </div>
          <div v-if="purchaseInfo.necessityAnalysis!=null" class="purchase-info-box">
            <div class="purchase-info-label">外包必要性</div>
            <div class="purchase-info-content" v-html="$options.filters.textareaToFormat(purchaseInfo.necessityAnalysis)"></div>
          </div>
          <div v-if="purchaseInfo.evaluationDescription!=null" class="purchase-info-box">
            <div class="purchase-info-label">评标建议</div>
            <div class="purchase-info-content" v-html="$options.filters.textareaToFormat(purchaseInfo.evaluationDescription)"></div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">发票抬头</div>
            <div class="purchase-info-content">{{purchaseInfo.companyName}}</div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">法务意见</div>
            <div class="purchase-info-content" v-html="$options.filters.textareaToFormat(purchaseInfo.legalopinion)"></div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">备注</div>
            <div class="purchase-info-content" v-html="$options.filters.textareaToFormat(purchaseInfo.description)"></div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">无法提供采购相关文档原因</div>
            <div class="purchase-info-content" v-html="$options.filters.textareaToFormat(purchaseInfo.unavailableDescription)"></div>
          </div>
          <div class="purchase-info-box">
            <div class="purchase-info-label">采购相关文档</div>
            <div class="purchase-info-content">
              <filebox message="暂无采购相关文档" :fileInfo="fileInfo"></filebox>
            </div>
          </div>
        </div>
        <div class="divide-line"></div>
        <div class="purchase-info-content">
          <div class="purchase-order">
            <div class="purchase-order-label">采购清单</div>
            <div class="purchase-order-Total">
              总金额
              <span>{{purchaseInfo.totalPrice|NumFormat}}元</span>
            </div>

            <div
              v-if="purchaseInfo.purchaseKindID==6||purchaseInfo.purchaseKindID==7||purchaseInfo.purchaseKindID==10"
              class="purchase-detail"
            >
              <div class="purchase-goods">{{purchaseInfo.detailsList[0].goodsName}}</div>
              <div class="purchase-detail-info">
                <div>数量</div>
                <div>{{purchaseInfo.detailsList[0].goodsNumber+purchaseInfo.detailsList[0].goodsUnits}}</div>
                <div>单价</div>
                <div>{{purchaseInfo.detailsList[0].mainSupplierPrice|NumFormat}}</div>
                <div>总价</div>
                <div>{{purchaseInfo.detailsList[0].mainSupplierTotalPrice|NumFormat}}</div>
              </div>
              <div class="purchase-goods">{{purchaseInfo.detailsList[0].mainSupplierName}}</div>
              <div class="purchase-supplier">
                <div class="supplier-label">联系人</div>
                <div class="supplier-value">{{purchaseInfo.detailsList[0].mainlinkMan}}</div>
              </div>
              <div class="purchase-supplier">
                <div class="supplier-label">联系方式</div>
                <div class="supplier-value">{{purchaseInfo.detailsList[0].maincontact}}</div>
              </div>
              <div class="purchase-supplier">
                <div class="supplier-label">网址</div>
                <div class="supplier-value">{{purchaseInfo.detailsList[0].mainwebSite}}</div>
              </div>
              <div class="purchase-supplier">
                <div class="supplier-label">选择理由</div>
                <div class="supplier-value" v-html="$options.filters.textareaToFormat(purchaseInfo.detailsList[0].mainaddCondition)"></div>
              </div>
            </div>
            <order
              v-else
              :purchaseDetailsList="purchaseInfo.detailsList"
              :supplierList="purchaseInfo.supDetailsList"
            ></order>
          </div>
        </div>
        <div class="divide-line"></div>
      </div>
      <div class="process d_jump">
        <process
          :approvalList="purchaseInfo.approvalList"
          :applyEmployeeID="purchaseInfo.applyEmployeeID"
          :currentStep="purchaseInfo.nextApproveStep"
        ></process>
      </div>
    </div>
    <div class="purchase-foot">
      <exefoot
        :paramInfo="{...paramInfo,approveStep:purchaseInfo.nextApproveStep,isEnd:purchaseInfo.isLastApproval}"
        v-if="purchaseInfo.nextApproverId&&purchaseInfo.nextApproverId.indexOf(userInfo.employeeID)>-1&&purchaseInfo.purApplyStatus=='SUBMIT'"
      ></exefoot>
      <selffoot
        :paramInfo="paramInfo"
        :urgeInfo="{approverUserId:purchaseInfo.nextApproverUserId,applyEmployeeName:purchaseInfo.currentApplyEmployeeName, applyTypeName:'采购申请'}"
        v-else-if="purchaseInfo.applyEmployeeID==userInfo.employeeID&&purchaseInfo.purApplyStatus=='SUBMIT'"
      ></selffoot>
      <passfoot :paramInfo="paramInfo" v-else></passfoot>
    </div>
  </div>
</template>
<script>
import headers from "@/components/Approval/ApprovalHead/index";
import tab from "@/components/Share/Tab";
import order from "@/components/Share/Table/Order";
import process from "@/components/Approval/ApprovalProcess/index";
import exefoot from "@/components/Approval/ApprovalFoot/approvalExeFoot";
import selffoot from "@/components/Approval/ApprovalFoot/approvalSelfFoot";
import passfoot from "@/components/Approval/ApprovalFoot/approvalPassFoot";
import filebox from "@/components/Share/Preview/fileBox";
import { mapState, mapMutations } from "vuex";
import http from "@/utils/http";
export default {
  data() {
    return {
      paramInfo: {},
      purchaseInfo: {},
      fileInfo: {},
      tabconfig: {
        defaultValue: 0,
        backFun: this.tabClickBackFun,
        affixNum: 0,
        tabList: [
          { key: 0, value: "申请信息" },
          { key: 1, value: "审批信息" }
        ]
      },
      applyState: { APPRYES: "已通过", SUBMIT: "审批中", APPRNO: "拒绝" }
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    ...mapMutations(["setTitleInfo"]),
    tabClickBackFun(index) {},
    getPurchaseInfo(applyId, applyTypeId) {
      let _this = this;
      this.$Spin.show();
      return new Promise((resolve, reject) => {
        http
          .get(
            `/api/FD/Purchase/GetPurchaseApplyInfo?applyId=${applyId}&applyTypeId=${applyTypeId}`
          )
          .then(res => {
            _this.$Spin.hide();
            if (res.data && res.data.data) {
              _this.setTitleInfo({
                title: "",
                bg: res.data.data.purApplyStatus,
                isMore: true
              });
              _this.fileInfo = {
                filesrcs: res.data.data.quotationPath,
                filenames: res.data.data.quotationFName
              };
              resolve(res.data.data || {});
            } else resolve({});
          });
      });
    }
  },
  async mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.tabconfig.affixNum = _this.$refs.tab.offsetTop - 1;
      _this.$refs.purchase_tab.style = "top:" + _this.tabconfig.affixNum + "px";
    });
    this.paramInfo = { ...this.$route.query };
    this.purchaseInfo = await this.getPurchaseInfo(
      this.paramInfo.applyId,
      this.paramInfo.applyTypeId
    );
  },
  components: {
    headers,
    tab,
    order,
    process,
    exefoot,
    selffoot,
    passfoot,
    filebox
  }
};
</script>
<style lang="less" scoped>
.purchase-box {
  .purchase-headers {
    padding: 0 0.4rem;
  }

  .purchase-tab {
    width: 100%;
    height: 1.44rem;
    position: sticky;
    z-index: 9;
    background: #fff;
    display: flex;
    align-items: center;
  }
  .mian-box {
    padding-bottom: 1.6rem;
    .purchase-info {
      .divide-line {
        width: 100%;
        height: 0.133333rem;
        background: #f5f5f5;
      }
      .purchase-info-content {
        padding: 0 0.4rem;
        .purchase-info-box {
          margin-top: 0.533333rem;
          font-size: 0.373333rem;
          display: flex;
          .purchase-info-label {
            text-align: center;
            flex: 1;
            color: #999;
          }
          .purchase-info-content {
            margin-left: 0.133333rem;
            width: 80%;
            color: #333333;
          }
        }
        .purchase-order {
          margin-bottom: 0.4rem;
          .purchase-order-label {
            height: 1.253333rem;
            line-height: 1.253333rem;
            font-size: 0.453333rem;
            color: #333333;
            font-weight: bold;
            border-bottom: 1px solid #eee;
          }
          .purchase-order-Total {
            height: 1.44rem;
            line-height: 1.44rem;
            font-size: 0.373333rem;
            color: #999999;
            padding-left: 0.4rem;
            span {
              color: #333333;
            }
          }
          .purchase-detail {
            border: 1px solid #dbdbdb;
            padding-bottom: 0.4rem;
            .purchase-goods {
              min-height: 1.08rem;
              padding: 0.213333rem 0 0.213333rem 0.266667rem;
              border-bottom: 1px solid #dbdbdb;
            }
            .purchase-detail-info {
              display: flex;
              text-align: center;
              border-bottom: 1px solid #dbdbdb;
              div {
                flex: 1;
                height: 1.08rem;
                line-height: 1.08rem;
                border-right: 1px solid #dbdbdb;
              }
            }
            .purchase-detail-info div:last-child {
              border-right: 0;
            }
            .purchase-supplier {
              width: 100%;
              min-height: 1.08rem;
              display: flex;
              align-items: center;

              .supplier-label {
                width: 1.8rem;
                text-align: center;
              }
              .supplier-value {
                flex: 1;
                padding-right: 0.3rem;
              }
            }
          }
        }
      }
    }
    .process {
      margin-top: 0.4rem;
      padding: 0 0.4rem;
    }
  }
  .purchase-foot {
    padding: 0 0.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: #fff;
    z-index: 9;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FD/Purchase/index.vue